import Fam from "../../../../src/pages/about/images/fam";
import React from 'react';
export default {
  Fam,
  React
};